// src/context/LoaderContext.js
import React, { createContext, useState, useContext } from "react";

const LoaderContext = createContext();
export const loaderRef = {};

export const LoaderProvider = ({ children }) => {
  const [loadingCount, setLoadingCount] = useState(0);

  const startLoading = () => {
    setLoadingCount((prev) => prev + 1);
  };

  const stopLoading = () => {
    setLoadingCount((prev) => Math.max(prev - 1, 0));
  };

  loaderRef.startLoading = startLoading;
  loaderRef.stopLoading = stopLoading;

  return (
    <LoaderContext.Provider value={{ loading: loadingCount > 0 }}>
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => useContext(LoaderContext);